import { collection, query, where, getDocs, doc, updateDoc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';
import { COLLECTIONS } from '../../constants/collections';

/**
 * Get all users belonging to a specific tenant
 */
export const getTenantUsers = async (tenantId) => {
    try {
        if (!tenantId) throw new Error('Tenant ID is required');
        const usersRef = collection(db, `tenants/${tenantId}/${COLLECTIONS.USERS}`);
        const querySnapshot = await getDocs(usersRef);
        return querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
    } catch (error) {
        console.error('Error fetching tenant users:', error);
        throw error;
    }
};

/**
 * Update a user's role
 */
export const updateUserRole = async (tenantId, userId, role) => {
    try {
        if (!tenantId) throw new Error('Tenant ID is required for user updates');
        const userRef = doc(db, `tenants/${tenantId}/${COLLECTIONS.USERS}`, userId);
        await updateDoc(userRef, { role });
    } catch (error) {
        console.error('Error updating user role:', error);
        throw error;
    }
};

/**
 * Update user status (active/inactive)
 */
export const updateUserStatus = async (tenantId, userId, isActive) => {
    try {
        if (!tenantId) throw new Error('Tenant ID is required for user updates');
        const userRef = doc(db, `tenants/${tenantId}/${COLLECTIONS.USERS}`, userId);
        await updateDoc(userRef, { isActive });
    } catch (error) {
        console.error('Error updating user status:', error);
        throw error;
    }
};

/**
 * Update a user's data scope (assigned factories, docks, etc.)
 */
export const updateUserScope = async (tenantId, userId, scope) => {
    try {
        if (!tenantId) throw new Error('Tenant ID is required for user updates');
        const userRef = doc(db, `tenants/${tenantId}/${COLLECTIONS.USERS}`, userId);
        await updateDoc(userRef, { scope });
    } catch (error) {
        console.error('Error updating user scope:', error);
        throw error;
    }
};

/**
 * Update user's personal profile information
 */
export const updateUserProfile = async (tenantId, userId, profileData) => {
    try {
        if (!tenantId) throw new Error('Tenant ID is required for user updates');
        const userRef = doc(db, `tenants/${tenantId}/${COLLECTIONS.USERS}`, userId);
        const { fullName, phone } = profileData;
        await updateDoc(userRef, {
            fullName,
            phone,
            updatedAt: new Date()
        });
    } catch (error) {
        console.error('Error updating user profile:', error);
        throw error;
    }
};
